import React, { useEffect, useState, createContext, useContext } from 'react';
import { LEARNING_PATH_DATA, calculateCourseProgress } from '../data/learningPathData';
interface LearningDataContextType {
  learningData: any[];
  updateLessonStatus: (courseId: number, unitId: number, lessonId: number, isCompleted: boolean) => void;
  loading: boolean;
}
const LearningDataContext = createContext<LearningDataContextType>({
  learningData: [],
  updateLessonStatus: () => {},
  loading: true
});
export const useLearningData = () => useContext(LearningDataContext);
export const LearningDataProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [learningData, setLearningData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Load learning data
    const savedData = localStorage.getItem('learningData');
    if (savedData) {
      setLearningData(JSON.parse(savedData));
    } else {
      // Initialize with default data
      setLearningData(LEARNING_PATH_DATA);
    }
    setLoading(false);
  }, []);
  const updateLessonStatus = (courseId: number, unitId: number, lessonId: number, isCompleted: boolean) => {
    setLearningData(prevData => {
      const updatedData = [...prevData];
      // Find the course
      const courseIndex = updatedData.findIndex(course => course.id === courseId);
      if (courseIndex === -1) return prevData;
      // Find the unit
      const unitIndex = updatedData[courseIndex].units.findIndex((unit: any) => unit.id === unitId);
      if (unitIndex === -1) return prevData;
      // Find the lesson
      const lessonIndex = updatedData[courseIndex].units[unitIndex].lessons.findIndex((lesson: any) => lesson.id === lessonId);
      if (lessonIndex === -1) return prevData;
      // Update lesson completion status
      updatedData[courseIndex].units[unitIndex].lessons[lessonIndex].isCompleted = isCompleted;
      // Recalculate unit progress
      const unit = updatedData[courseIndex].units[unitIndex];
      const completedLessons = unit.lessons.filter((lesson: any) => lesson.isCompleted).length;
      updatedData[courseIndex].units[unitIndex].progress = Math.round(completedLessons / unit.lessons.length * 100);
      // Recalculate course progress
      updatedData[courseIndex].progress = calculateCourseProgress(updatedData[courseIndex]);
      updatedData[courseIndex].completedLessons = updatedData[courseIndex].units.reduce((total: number, unit: any) => total + unit.lessons.filter((lesson: any) => lesson.isCompleted).length, 0);
      // Save to localStorage
      localStorage.setItem('learningData', JSON.stringify(updatedData));
      return updatedData;
    });
  };
  return <LearningDataContext.Provider value={{
    learningData,
    updateLessonStatus,
    loading
  }} data-id="element-1729">
      {children}
    </LearningDataContext.Provider>;
};